export default __webpack_public_path__ + "static/media/recent_tests.0f730ad2.svg";